const routes = [
    {
        path: "/sessions",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "session_index"
        }
    }
];

export default routes;
